<template>
  <el-container :class="['ttn-body', { 'ht-form': hardwareType === 'form' }]">
    <el-aside v-if="hardwareType !== 'form'" class="ttn-aside" width="308px">
      <el-row :gutter="24">
        <el-col v-for="img in uploadImgs" :key="img.field" :span="12">
          <div class="title-file">{{ img.title }}</div>
          <upload-img
            :id="getField(img.field).id"
            :small="true"
            :text="true"
            :img="getField(img.field).file_url"
            :hardware="isHardwareModal"
            @changed="file => getFileFront(file, img.formField)"
            @delete="deleteFile"
          />
        </el-col>
      </el-row>
      <el-button
        v-if="ttn && !isHardwareModal"
        type="primary"
        class="ttn-btn ttn-btn-print"
        @click="onDownload"
      >
        Распечатать ТТН
      </el-button>
    </el-aside>
    <el-container>
      <el-main>
        <el-form
          ref="ttn-form"
          :model="formData"
          :rules="rules"
          :label-position="isMobile ? 'top' : 'right'"
          label-width="75px"
        >
          <el-row>
            <el-col :xs="24" :sm="24" :lg="12" class="pr-10">
              <el-form-item prop="number" label="№ ТТН:">
                <el-input
                  v-model="formData.number"
                  placeholder="№ ТТН"
                  :size="hardwareType === 'form' ? 'medium' : ''"
                  :disabled="isHardwareModal"
                />
              </el-form-item>
            </el-col>
            <el-col :xs="24" :sm="24" :lg="12">
              <el-form-item prop="date" label="Дата:">
                <el-date-picker
                  v-model="formData.date"
                  type="date"
                  placeholder="Выберите дату"
                  :size="hardwareType === 'form' ? 'medium' : ''"
                  :picker-options="pickerOpt"
                  :disabled="isHardwareModal"
                  value-format="yyyy-MM-dd"
                />
              </el-form-item>
              <div v-if="!isHardwareModal" class="box-load-date">
                <el-link
                  class="load-date"
                  type="primary"
                  @click="onLoadDate(loadDate)"
                >
                  {{ dateToFormat(loadDate, 'defaultDateRu') }}
                </el-link>
              </div>
            </el-col>
          </el-row>
          <el-row>
            <el-col
              :offset="12"
              :xs="24"
              :sm="24"
              :lg="12"
              class="text-align-right"
            />
          </el-row>
          <el-row class="title">ВЕС ПОГРУЖЕННЫЙ, кг:</el-row>
          <el-row>
            <el-col :xs="24" :sm="24" :lg="9" class="pr-10">
              <el-form-item prop="brutto_ttn" label="БРУТТО:">
                <el-input
                  ref="brutto_ttn"
                  v-model="formData.brutto_ttn"
                  :controls="false"
                  :min="0"
                  :size="hardwareType === 'form' ? 'medium' : ''"
                  :disabled="isHardwareModal"
                  placeholder="БРУТТО"
                  @input="onFocusBrutoTtnNextInputHandler"
                />
              </el-form-item>
            </el-col>
            <el-col :xs="24" :sm="24" :lg="9" class="pr-10">
              <el-form-item prop="netto_ttn" label="НЕТТО:">
                <el-input
                  ref="netto_ttn"
                  v-model="formData.netto_ttn"
                  :controls="false"
                  :min="0"
                  :size="hardwareType === 'form' ? 'medium' : ''"
                  :disabled="isHardwareModal"
                  placeholder="НЕТТО"
                  @input="maxLengthNettoTtnHandler"
                />
              </el-form-item>
            </el-col>
            <el-col :xs="24" :sm="24" :lg="6">
              <el-form-item label="ТАРА:">
                <span class="tare-val" :class="isInt(tarettn)">
                  {{ tarettn }} кг
                </span>
              </el-form-item>
            </el-col>
          </el-row>
          <el-row class="title green">ВЕС ВЫГРУЖЕННЫЙ, кг:</el-row>
          <el-row>
            <el-col :xs="24" :sm="24" :lg="9" class="pr-10">
              <el-form-item prop="brutto_fact" label="БРУТТО:">
                <el-input
                  ref="brutto_fact"
                  v-model="formData.brutto_fact"
                  :controls="false"
                  :size="hardwareType === 'form' ? 'medium' : ''"
                  :disabled="!enabled || isHardwareModal"
                  placeholder="БРУТТО"
                  @input="onFocusBrutoFactNextInputHandler"
                />
              </el-form-item>
            </el-col>
            <el-col :xs="24" :sm="24" :lg="9" class="pr-10">
              <el-form-item prop="netto_fact" label="НЕТТО:">
                <el-input
                  ref="netto_fact"
                  v-model="formData.netto_fact"
                  :controls="false"
                  :size="hardwareType === 'form' ? 'medium' : ''"
                  :disabled="!enabled || isHardwareModal"
                  placeholder="НЕТТО"
                  @input="maxLengthNettoFactHandler"
                />
              </el-form-item>
            </el-col>
            <el-col :xs="24" :sm="24" :lg="6">
              <el-form-item label="ТАРА:">
                <span class="tare-val" :class="isInt(tarefact)">
                  {{ tarefact }} кг
                </span>
              </el-form-item>
            </el-col>
          </el-row>
          <el-divider />
          <el-row type="flex" align="middle">
            <el-col :xs="24" :sm="24" :lg="12" class="pr-10">
              <el-form-item prop="type_code" label-width="0px">
                <div class="custom-title">ТИП ТТН:</div>
                <el-select
                  v-model="formData.type_code"
                  :size="hardwareType === 'form' ? 'medium' : ''"
                  :disabled="isHardwareModal"
                >
                  <el-option
                    v-for="type in typeCodesShort"
                    :key="type.label"
                    :label="type.title"
                    :value="type.label"
                  />
                </el-select>
              </el-form-item>
            </el-col>
            <el-col :xs="24" :sm="24" :lg="12" class="ta-r">
              <el-form-item
                prop="underweight"
                label="НЕДОВОЗ:"
                class="underweight"
              >
                <span class="tare-val" :class="isInt(underweight)">
                  {{ underweight }} кг
                </span>
              </el-form-item>
              <el-form-item label="НЕДОВОЗ СВЕРХ НОРМЫ:" class="underweight">
                <span class="tare-val" :class="isInt(oversupply)">
                  {{ oversupply }} кг
                </span>
              </el-form-item>
            </el-col>
          </el-row>
          <el-divider v-if="hardwareType === 'form'" />
          <el-row v-if="hardwareType === 'form'">
            <el-col :xs="24" :sm="24" :lg="12">
              <el-form-item prop="date_loaded" label-width="0px">
                <div class="custom-title">Начало погрузки:</div>
                <el-date-picker
                  v-model="formData.date_loaded"
                  type="datetime"
                  placeholder="Выберите дату и время"
                  :size="hardwareType === 'form' ? 'medium' : ''"
                  :picker-options="pickerOpt"
                  :disabled="isHardwareModal"
                  prefix-icon="el-icon-date"
                  value-format="yyyy-MM-dd HH:mm:ss"
                />
              </el-form-item>
              <el-link
                class="load-date"
                type="primary"
                @click="
                  onLoadDate(
                    dateToFormat(loadDate, 'defaultDatePickerFormat'),
                    'date_loaded',
                  )
                "
              >
                {{ dateToFormat(loadDate, 'defaultDateRu') }}
              </el-link>
            </el-col>
            <el-col :xs="24" :sm="24" :lg="12">
              <el-form-item prop="date_unloaded" label-width="0px">
                <div class="custom-title">Окончание погрузки:</div>
                <el-date-picker
                  v-model="formData.date_unloaded"
                  type="datetime"
                  placeholder="Выберите дату и время"
                  :size="hardwareType === 'form' ? 'medium' : ''"
                  :picker-options="pickerOpt"
                  :disabled="isHardwareModal"
                  prefix-icon="el-icon-date"
                  value-format="yyyy-MM-dd HH:mm:ss"
                />
              </el-form-item>
            </el-col>
          </el-row>
        </el-form>
      </el-main>
      <el-footer height="auto">
        <template v-if="!hardwareType">
          <el-button
            v-if="canAction('deleteTTN') && ttn && ttn.id"
            type="danger"
            @click="delTTN"
          >
            Удалить
          </el-button>
          <el-button type="primary" @click="checkOversupply">
            Сохранить
          </el-button>
        </template>
        <el-button v-else type="primary" class="mt-20" @click="handleNext">
          {{ getBtnTitle() }}
        </el-button>
      </el-footer>
    </el-container>
  </el-container>
</template>

<script>
import { RepositoryFactory } from '@/api/RepositoryFactory'

import { getRules, uploadImgs } from '@/components/Forms/constants'
import { pickerOpt, typeCodesShort } from '@/datas/consts'
import { roundUp } from '@/helpers/functions'
import UploadImg from '@/components/Upload/UploadImg'

const TTN = RepositoryFactory.get('ttn')
const Doc = RepositoryFactory.get('doc')

export default {
  name: 'FormTTN',
  components: { UploadImg },
  props: {
    responseId: {
      type: Number,
      default: 0,
    },
    ttn: {
      type: Object,
      default: () => null,
    },
    shortage: {
      type: Object,
      default: () => {},
    },
    loadDate: {
      type: String,
      default: '',
    },
    defaultType: {
      type: String,
      default: '',
    },
    hardwareType: {
      type: String,
      default: '',
    },
    clear: {
      type: Boolean,
      default: false,
    },
    statusDates: {
      type: Object,
      default: () => {},
    },
  },
  data() {
    return {
      formData: {
        number: undefined,
        date: undefined,
        brutto_ttn: undefined,
        netto_ttn: undefined,
        brutto_fact: undefined,
        netto_fact: undefined,
        fileFront: undefined,
        fileBack: undefined,
        fileFrontTn: undefined,
        fileBackTn: undefined,
        type_code: undefined,
        date_loaded: undefined,
        date_unloaded: undefined,
      },
      imgUrlFront: '',
      imgUrlBack: '',
      imgUrlFrontTn: '',
      imgUrlBackTn: '',
      rules: getRules(this.checkTTN, this.checkFact),
      uploadImgs,
      pickerOpt,
      typeCodesShort,
    }
  },
  computed: {
    isHardwareModal() {
      return this.hardwareType === 'modal'
    },
    tarettn() {
      const { brutto_ttn, netto_ttn } = this.formData
      const res = brutto_ttn - netto_ttn

      return isNaN(res) ? 0 : res
    },
    tarefact() {
      const { brutto_fact, netto_fact } = this.formData
      const res = brutto_fact - netto_fact

      return isNaN(res) ? 0 : res
    },
    underweight() {
      const { netto_ttn, netto_fact } = this.formData
      const res = netto_ttn - netto_fact

      return isNaN(res) || res < 0 ? 0 : roundUp(res)
    },
    oversupply() {
      const { netto_ttn, netto_fact } = this.formData
      const { perc, val } = this.shortage
      const shortage = perc ? (netto_ttn * val) / 100 : val
      const res = netto_ttn - netto_fact - shortage

      return isNaN(res) || res < 0 ? 0 : roundUp(res)
    },
    enabled() {
      const { netto_ttn, brutto_ttn } = this.formData

      return netto_ttn > 0 && brutto_ttn > 0
    },
    isInt() {
      return num => (num <= 0 ? 'red' : '')
    },
  },
  watch: {
    ttn: {
      immediate: true,
      handler(val) {
        if (val) {
          for (let k in this.formData) {
            if (!k.includes('date_')) {
              this.formData[k] = val[k]
            }
          }

          if (this.hardwareType !== 'form') {
            this.setFiles(val.files)
          }
        } else {
          this.resetFields()
          this.formData.type_code =
            !this.defaultType || this.defaultType === 'delivery'
              ? 'delivery'
              : 'harvest'
        }
        this.$refs['ttn-form']?.clearValidate()
      },
    },
    responseId: {
      immediate: true,
      handler(id) {
        if (id) {
          this.getTTNs(0)
        }
      },
    },
    clear(val) {
      if (val) {
        this.resetFields()
        this.$emit('clear')
      }
    },
    statusDates: {
      immediate: true,
      handler(dates) {
        if (this.hardwareType === 'form') {
          if (!this.formData.date_loaded) {
            this.formData.date_loaded = dates?.date_loaded || undefined
          }
          if (!this.formData.date_unloaded) {
            this.formData.date_unloaded = dates?.date_unloaded || undefined
          }
        }
      },
    },
  },
  methods: {
    getField(field) {
      return this[field]
    },
    getBtnTitle() {
      return this.isHardwareModal
        ? 'Выбрать ТТН и перейти к редактированию'
        : 'Проверить ориентацию изображений и сохранить'
    },
    handleNext() {
      if (this.isHardwareModal) {
        this.$emit('next', this.ttn)
      } else {
        this.checkOversupply()
      }
    },
    setFiles(files) {
      const front = files.find(file => file.name === 'front')

      this.imgUrlFront = front ? front : ''
      const back = files.find(file => file.name === 'back')

      this.imgUrlBack = back ? back : ''
      const frontTn = files.find(file => file.name === 'frontTn')

      this.imgUrlFrontTn = frontTn ? frontTn : ''
      const backTn = files.find(file => file.name === 'backTn')

      this.imgUrlBackTn = backTn ? backTn : ''
    },
    onFocusBrutoTtnNextInputHandler(v) {
      this.formData.brutto_ttn = this.maxLenghtFive(v)
      this.onFocusNext(this.formData.brutto_ttn, 'netto_ttn')
    },
    maxLengthNettoTtnHandler(v) {
      this.formData.netto_ttn = this.maxLenghtFive(v)
    },
    onFocusBrutoFactNextInputHandler(v) {
      this.formData.brutto_fact = this.maxLenghtFive(v)
      this.onFocusNext(this.formData.brutto_fact, 'netto_fact')
    },
    maxLengthNettoFactHandler(v) {
      this.formData.netto_fact = this.maxLenghtFive(v)
    },
    onFocusNext(data, ref) {
      if (data.length === 5) {
        this.$refs[ref].focus()
      }
    },
    maxLenghtFive(str = '') {
      return str.replace(/[^\d]/g, '').substr(0, 5)
    },
    getFileFront(file, field) {
      this.formData[field] = file
    },
    getFileBack(file) {
      this.formData.fileBack = file
    },
    getFileFrontTn(file) {
      this.formData.fileFrontTn = file
    },
    getFileBackTn(file) {
      this.formData.fileBackTn = file
    },
    checkTTN(rule, value, callback) {
      const { brutto_ttn, netto_ttn } = this.formData

      if (!value) {
        callback(new Error('Заполните поле'))
      } else if (String(value).length < 4) {
        callback(new Error('В поле должно быть от 4 символов'))
      } else if (brutto_ttn >= 0 && netto_ttn >= 0 && this.tarettn <= 0) {
        callback(new Error('Брутто должно быть больше нетто!'))
      } else if (brutto_ttn >= 0 && netto_ttn >= 0) {
        this.$refs['ttn-form'].clearValidate(['brutto_ttn', 'netto_ttn'])
      }

      callback()
    },
    checkFact(rule, value, callback) {
      const { brutto_fact, netto_fact } = this.formData

      if (brutto_fact >= 0 && netto_fact > 0 && this.tarefact <= 0) {
        callback(new Error('Брутто должно быть больше нетто!'))
      } else if (String(value).length < 4) {
        callback(new Error('В поле должно быть от 4 символов'))
      } else {
        this.$refs['ttn-form'].clearValidate(['brutto_fact', 'netto_fact'])
      }

      callback()
    },
    getFormData() {
      const formData = new FormData()

      for (let k in this.formData) {
        if (this.formData[k] !== undefined) {
          if (!this.enabled && (k === 'brutto_fact' || k === 'netto_fact')) {
            continue
          }
          if (k === 'date') {
            this.formData[k] = this.dateToFormat(
              this.formData[k],
              'defaultDate',
            )
          }
          formData.append(k, this.formData[k])
        }
      }

      return formData
    },
    checkOversupply() {
      if (this.oversupply > 1000) {
        this.$confirm(
          '',
          `${this.oversupply} превышает 1000 кг, проверьте правильность заполнения формы`,
          {
            confirmButtonText: 'Все верно',
            cancelButtonText: 'Отмена',
            type: 'warning',
            center: true,
            closeOnClickModal: false,
            closeOnPressEscape: false,
            closeOnHashChange: false,
          },
        )
          .then(() => this.submitForm())
          .catch(() => false)
      } else {
        this.submitForm()
      }
    },
    deleteFile(id) {
      this.$emit('loading', true)
      TTN.deleteFile(this.ttn.id, id)
        .then(() => {
          this.imgUrlFront = this.imgUrlFront.id === id ? '' : this.imgUrlFront
          this.imgUrlBack = this.imgUrlBack.id === id ? '' : this.imgUrlBack
          this.imgUrlFrontTn =
            this.imgUrlFrontTn.id === id ? '' : this.imgUrlFrontTn
          this.imgUrlBackTn =
            this.imgUrlBackTn.id === id ? '' : this.imgUrlBackTn
        })
        .catch(err => this.errHandler(err))
        .finally(() => this.$emit('loading'))
    },
    getTTNs(flag = -2) {
      this.$emit('loading', true)
      TTN.getList(this.responseId)
        .then(res => {
          const { status, data } = res

          if (status === 200 && data) {
            this.$emit('invoices', data, flag)
          }
        })
        .catch(e => this.errHandler(e))
        .finally(() => this.$emit('loading'))
    },
    submitForm() {
      this.$refs['ttn-form'].validate(valid => {
        if (valid) {
          if (this.hardwareType) {
            this.$emit('next', {
              ...this.formData,
              response_id: this.responseId,
            })
          } else {
            const formData = this.getFormData()

            if (this.ttn) {
              this.updateTTN({
                id: this.ttn.id,
                data: formData,
                fileIds: {
                  front: this.imgUrlFront ? this.imgUrlFront.id : null,
                  back: this.imgUrlBack ? this.imgUrlBack.id : null,
                  frontTn: this.imgUrlFrontTn ? this.imgUrlFrontTn.id : null,
                  backTn: this.imgUrlBackTn ? this.imgUrlBackTn.id : null,
                },
              })
            } else {
              formData.append('response_id', String(this.responseId))
              this.saveTTN(formData)
              this.resetFields()
            }
          }
        }
      })
    },
    saveTTN(data) {
      this.$emit('loading', true)
      TTN.postItem(data)
        .then(async res => {
          await this.uploadTtnFiles(data, res)
        })
        .catch(err => this.errHandler(err))
        .finally(() => this.$emit('loading'))
    },
    updateTTN({ id, data, fileIds }) {
      this.$emit('loading', true)
      TTN.updateItem(id, data)
        .then(async res => {
          await this.uploadTtnFiles(data, res, fileIds)
        })
        .catch(err => this.errHandler(err))
        .finally(() => this.$emit('loading'))
    },
    delTTN() {
      this.$emit('loading', true)
      TTN.deleteItem(this.ttn.id)
        .then(() => {
          this.getTTNs(-1)
          this.handleUpdate('удален')
        })
        .catch(err => this.errHandler(err))
        .finally(() => this.$emit('loading'))
    },
    handleUpdate(text) {
      this.$emit('update')
      this.$message.success(`ТТН успешно ${text}`)
    },
    async uploadTtnFiles(data, res, fileIds) {
      if (data.get('fileFront')) {
        if (fileIds?.front) {
          await this.updateUploadTtnFile(
            res.data.id,
            data,
            'front',
            fileIds.front,
          )
        } else {
          await this.uploadTtnFile(res.data.id, data, 'front')
        }
      }
      if (data.get('fileFrontTn')) {
        if (fileIds?.frontTn) {
          await this.updateUploadTtnFile(
            res.data.id,
            data,
            'frontTn',
            fileIds.frontTn,
          )
        } else {
          await this.uploadTtnFile(res.data.id, data, 'frontTn')
        }
      }
      if (data.get('fileBack')) {
        if (fileIds?.back) {
          await this.updateUploadTtnFile(
            res.data.id,
            data,
            'back',
            fileIds.back,
          )
        } else {
          await this.uploadTtnFile(res.data.id, data, 'back')
        }
      }
      if (data.get('fileBackTn')) {
        if (fileIds?.backTn) {
          await this.updateUploadTtnFile(
            res.data.id,
            data,
            'backTn',
            fileIds.backTn,
          )
        } else {
          await this.uploadTtnFile(res.data.id, data, 'backTn')
        }
      }
      this.getTTNs()
      this.handleUpdate(fileIds ? 'обновлен' : 'создан')
    },
    async uploadTtnFile(id, data, type) {
      await TTN.upload(id, data, type)
        .then(() => {})
        .catch(err => this.errHandler(err))
    },
    async updateUploadTtnFile(id, data, type, fileId) {
      await TTN.updateUploadFile(id, data, type, fileId)
        .then(() => {})
        .catch(err => this.errHandler(err))
    },
    resetFields() {
      this.formData = {
        ...this.formData,
        number: undefined,
        date: undefined,
        brutto_ttn: undefined,
        netto_ttn: undefined,
        brutto_fact: undefined,
        netto_fact: undefined,
        fileFront: undefined,
        fileBack: undefined,
        fileFrontTn: undefined,
        fileBackTn: undefined,
        type_code: undefined,
        date_loaded: undefined,
        date_unloaded: undefined,
      }
      this.imgUrlFront = ''
      this.imgUrlBack = ''
      this.imgUrlFrontTn = ''
      this.imgUrlBackTn = ''
    },
    onDownload() {
      if (this.ttn) {
        const { id, number, date } = this.ttn

        Doc.getTTN(id)
          .then(res =>
            this.downloadRegistry({
              res,
              headerContent: `TTH№${number}_${this.dateToFormat(
                date,
                'defaultDateRu',
              )}`,
            }),
          )
          .catch(err => this.errHandler(err))
      }
    },
    onLoadDate(date, field = 'date') {
      this.formData[field] = date
      this.$refs['ttn-form'].clearValidate([field])
    },
  },
}
</script>

<style lang="sass">
.ttn-aside
  margin-right: 16px
.text-align-right
  text-align: right
.box-load-date
  text-align: left
  margin-top: -5px
  margin-left: 75px
.ttn-body
  margin-top: 30px
  &.ht-form
    margin-top: 0
    .custom-title
      position: relative
      line-height: 28px
      color: #000
      &:before
        content: '*'
        color: #F56C6C
        margin-right: 4px
    .el-main .el-divider.el-divider--horizontal
      margin-bottom: 10px
  .mt-20
    margin-top: 20px
  .el-upload
    width: 100% !important
    .el-button
      width: 100% !important
  .el-aside
    padding: 0 10px
  .el-button
    font-size: 15px
  .el-col-sm-18
    width: 75%
  .el-form-item__content
    line-height: 40px
  .el-form-item__label
    color: #000
  .el-input-number .el-input__inner
    text-align: left
  .pr-10
    padding-right: 10px
  .el-input-number, .el-date-editor.el-input, .el-date-editor.el-input__inner
    width: auto
  .el-dialog__footer
    border: none
  .el-main
    padding: 0
    .el-divider.el-divider--horizontal
      background-color: #000
      margin: 10px 0 20px
  .el-footer
    text-align: right
  .title
    color: #409EFF
    font-weight: bold
    margin: 10px 0
    &.green
      color: #00B754
  & .title-file
    display: block
    text-align: center
    font-size: 13px
    color: #606266
  .tare-val
    color: #00B754 !important
    &.red
      color: #FF0000 !important
      .el-input__inner
        color: #FF0000 !important
    .el-input__inner
      color: #00B754 !important
  .underweight
    display: flex
    justify-content: flex-end
    align-items: center
    .el-form-item__label
      width: 190px !important
      line-height: 18px
      word-break: break-word
    .el-form-item__content
      margin-left: 0 !important
      text-align: left
      min-width: 55px
      line-height: 1
    .el-input.is-disabled .el-input__inner
      border: none
      background: #fff
      color: #000
  .ttn-btn
    margin: 30px 0 0
    width: 240px
  .ttn-btn-print
    margin: 8px 0 0
    width: 100%
</style>
